import $ from "jquery";
import * as _ from "underscore";

const url = "//fonts.googleapis.com/css?family=Open+Sans:400,700";
const subsets = ["latin"];

export const init = () => {
  $("head").append(
    '<link id="openSansFont" rel="stylesheet" type="text/css" href="' +
      url +
      '" />'
  );
};

export const loadSubset = (subset) => {
  if (!_.contains(subsets, subset)) {
    subsets.push(subset);
    $("link#openSansFont").attr("href", url + "&subset=" + subsets.join(","));
  }
};
